import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function CaretDownIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 8} height={height || 5.091} viewBox="0 0 8 5.091">
      <path
        d="M.538 0h6.923a.614.614 0 01.379 1.029L4.38 4.914a.5.5 0 01-.761 0L.159 1.029A.614.614 0 01.538 0z"
        fill={color || "#fb972e"}
      />
    </svg>
  );
}
